// i18n area 'vms' — locale sv-SE (task #171, onda 2): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/vms.sv-SE.meta.json.
import type { enUS } from './vms'

export const svSE: typeof enUS = {
  vms: {
    spof: {
      title: 'Oberoende av noden',
      single: 'Enskild felpunkt',
      alternativesNow: 'Alternativ nu',
      structural: 'Genom konstruktion',
      binding: 'Bindande begränsning',
      movableNow: 'Kan migreras nu',
    },
    title: 'Virtuella maskiner',
    migratingChip: 'Migrering pågår',
    templateChip: 'Template',
    expendableTooltip: 'I ett degraderat kluster är den bland de första som stoppas och startar kanske inte om efter förlust av en nod.',
    expendableHaTooltip: 'Startas alltid om så länge klustret är friskt; i ett degraderat kluster går skyddade VM:ar först — den kan stoppas eller förbli avstängd tills klustret är helt igen, sedan återvänder den av sig själv.',
    viewDetails: 'Visa detaljer',
    profileLegacy: 'Annat OS',
    hugePagesNone: 'Ingen — vanligt minne',
    hugePages2M: '2 MiB-sidor',
    hugePages1G: '1 GiB-sidor',
    searchPlaceholder: 'Sök på namn',
    name: 'Namn',
    vcpus: 'vCPU',
    memory: 'Minne',
    ipAddresses: 'IP-adresser',
    noIp: 'Ingen IP',
    authorityNode: 'Authority',
    authorityNextStart: 'tilldelas vid nästa start',
    scope: 'Scope',
    empty: 'Inga virtuella maskiner',
    loadError: 'Kunde inte läsa in de virtuella maskinerna — är TVirt-backenden nåbar?',
    filterOverlay: 'overlay-nätverk',
    filterDisk: 'disk',
    filterImage: 'avbild',
    filteredBy: 'Filtrerade på {kind}',
    filterPhase: 'Fas',
    filterProtection: 'Skydd',
    filterAll: 'Alla',
    filterScopePlaceholder: 'Filtrera på scope',
    filtersToggle: 'Filter',
    scopeTree: {
      title: 'Scope',
      all: 'Hela klustret',
      noChildren: 'Inga under-scope här',
      recursive: 'Inkludera underordnade',
      collapse: 'Fäll ihop scope-panelen',
      up: 'Gå upp en nivå',
      countTooltip: '{direct} VM i detta scope · {total} med underordnade'
    },
    isoPicker: {
      catalog: 'Katalog',
      unknownCatalog: 'Utanför de synliga katalogerna',
      noIsos: 'Inga färdiga ISO-avbilder i den här katalogen'
    },
    actionsHeader: 'Åtgärder',
    templatesTab: {
      quickDeploy: 'QuickDeploy',
      hardware: 'Maskinvara',
      tags: 'Taggar',
      age: 'Ålder',
      disk: 'disk',
      disks: 'diskar',
      empty: 'Inga templates — markera en avstängd VM som template, eller klona en VM som template.',
      clone: 'Klona / deploy',
      editTags: 'Redigera taggar',
      exportAction: 'Exportera till katalogen (.tvtpl)',
      exportTitle: 'Exportera till katalogen',
      exportSubmit: 'Exportera',
      exportError: 'Exporten misslyckades',
      exportHint: 'Templaten paketeras i ett .tvtpl-arkiv (maskinvarumanifest + varje disk utplattad till qcow2) som en ny Template VM-fil i den valda katalogen. NIC, CD/DVD-medier och cloud-init följer inte med — formatets spec listar varje avsiktlig utelämning.',
      exportName: 'Filnamn',
      exportNameHint: 'Tomt = <template>-export-<n>',
      exportStorageDefault: 'Templatens metadata-storage',
      importAction: 'Importera från katalog',
      importTitle: 'Importera från katalog',
      importHint: 'En ready Template VM-fil från den valda katalogen blir en template i inventariet: filens format (tvtpl, ova, ovf eller naken qcow2) avgör på egen hand hur importen sker — du väljer bara filen.',
      importFile: 'Katalogfil',
      importFileHint: 'Endast ready-filer kan importeras — en fil mitt i en upload går inte att importera',
      importNoFiles: 'Inga ready Template VM-filer i den här katalogen — ladda upp eller exportera en först'
    },
    templateDetail: {
      quickDeploy: 'QuickDeploy-kompatibilitet',
      quickDeployNone: 'Inte deklarerad',
      quickDeployHint: 'Deklarera den bara om golden-avbildningen innehåller cloud-init (Linux) eller cloudbase-init efter sysprep /generalize (Windows): plattformen litar på deklarationen och tittar aldrig in i gästen.',
      notFound: 'Templaten hittades inte',
      frozen: 'Maskinvarukonfigurationen är frusen: gör om templaten till VM för att ändra den. Namn, anteckningar och taggar kan fortfarande ändras.',
      storage: 'Storage',
      size: 'Storlek',
      configTitle: 'Konfiguration (frusen)',
      usbClasses: 'Begärda USB-klasser',
      gpuClasses: 'Begärda GPU-klasser'
    },
    sharedDisksTab: {
      title: 'Delade diskar',
      sharing: 'Delning',
      sharingNone: 'En enda koppling',
      sharingMultiwriter: 'Delad skrivning (multiwriter)',
      sharingReadonly: 'Delad skrivskyddad',
      usedBy: 'Används av',
      attachedTo: 'Kopplad till',
      notAttached: 'Inte kopplad till någon VM',
      changeSharing: 'Ändra delningsläge',
      changeSharingTitle: 'Delningsläge',
      changeSharingLocked: 'Läget ändras bara medan ingen VM använder disken',
      sharingChanged: 'Delningsläget uppdaterat.',
      lun: 'Hel LUN',
      lunNumber: 'LUN / namespace',
      lunWwn: 'WWN',
      lunSerial: 'Serienummer',
      antiAffinityWarning: 'Två eller fler medlemmar kör på samma nod utan anti-affinitetsregel: ett nodfel tar ner alla',
      antiAffinityCreate: 'Skapa regeln',
      createSourceLun: 'Ta över en hel LUN från targeten',
      createLunNumber: 'LUN-nummer (namespace-id på NVMe)',
      createLunHint: 'Inget allokeras: storleken läses från enheten vid övertagandet',
      noPr: 'Inga SCSI-3 persistent reservations i den här utgåvan: ett Windows Failover Cluster med klassisk delad disk är inte validerat; kluster som koordinerar över nätet (GFS2/OCFS2, RHEL HA, shared-disk-databaser) är det'
    },
    unusedDisksTab: {
      title: 'Oanvända diskar',
      attach: 'Anslut till en VM',
      attachTitle: 'Anslut till en VM',
      vm: 'Virtuell maskin',
      noVms: 'Ingen VM tillgänglig',
      noSlots: 'Inga lediga slots på den här VM:en',
      create: 'Skapa disk',
      createTitle: 'Skapa disk',
      createSourceBlank: 'Tom disk',
      createSourceImage: 'Från en avbild i katalogen',
      createImage: 'Avbild',
      createImageEmpty: 'Ingen klar VM-mallavbild i de synliga katalogerna',
      createSizeFromImageHint: 'Förifylld med avbildens virtuella storlek — den kan bara växa',
      convert: 'Konvertera till VM-template…',
      convertOnlyQcow2: 'Endast qcow2-diskar kan konverteras — raw är inte ett registrerbart template-format',
      convertTitle: 'Konvertera till VM-template',
      convertSubmit: 'Konvertera (förstör disken)',
      convertError: 'Kunde inte starta konverteringen',
      convertWarning: 'DESTRUKTIVT: disken blir en VM-template-fil i den valda katalogen — samma storage, noll byte kopieras — och UPPHÖR ATT EXISTERA som disk. Det går inte att ångra annat än genom att skapa en ny disk från templaten.',
      convertNameHint: 'Katalogfilens namn — diskens namn som standard',
      convertConfirm: 'Jag förstår: disken kommer att förstöras',
      convertStarted: 'Konverteringen har startat — templaten dyker upp i katalogen när tasken är klar.',
      storageLockHint: 'Storagen byts bara via åtgärden Flytta',
      source: 'Ursprung',
      sourceClone: 'Klon av en annan disk',
      sourceCloneLinked: 'Linked clone av en annan disk',
      sourceImage: 'Skapad från en avbild',
      sourceBlank: 'Skapad tom',
      allocated: 'Allokerat / virtuell storlek',
      observedAt: 'Observerad den',
      snapshots: 'Snapshots',
      snapshotsEmpty: 'Inga snapshots'
    },
    phase: {
      defined: 'Aldrig påslagen',
      starting: 'Startar',
      running: 'Körs',
      stopping: 'Stängs av',
      stopped: 'Avstängd',
      paused: 'Pausad',
      failed: 'I feltillstånd',
      deleting: 'Tas bort'
    },
    stopCause: {
      'api': 'Stoppad av TVirt (åtgärd eller API)',
      'guest-shutdown': 'Avstängning initierad av guest-operativsystemet',
      'crash': 'Guesten kraschade',
      'qemu-exit': 'QEMU-processen avslutades oväntat',
      'host-reboot': 'Noden startades om',
      'migrated': 'Migrerad till en annan nod',
      'fenced': 'Terminerad av HA-fencing (noden kom tillbaka)'
    },
    detail: {
      notFound: 'Den virtuella maskinen hittades inte',
      details: 'Detaljer',
      id: 'ID',
      scope: 'Scope',
      profile: 'Maskinvaruprofil',
      firmware: 'Firmware',
      firmwareFile: 'UEFI-firmwareversion',
      firmwareUpdate: 'Uppdatering tillgänglig',
      firmwareUpdateHint: 'Plattformen levererar en nyare UEFI-firmware. Uppdateringen sker aldrig automatiskt: den tillämpas när VM:en är avstängd, när du bestämmer det.',
      arch: 'Arkitektur',
      node: 'Nod',
      bootOrder: 'Boot-ordning',
      agent: 'Agentstatus',
      agentConnected: 'Ansluten',
      agentNotConnected: 'Inte ansluten',
      protected: 'Skyddad',
      linkedClones: 'Länkade kloner',
      restartPolicy: 'Omstartspolicy',
      preferredNode: 'Föredragen nod',
      noPreference: 'Ingen preferens (automatisk placering)',
      preferNodes: 'Föredragna nodtaggar',
      requireNodes: 'Obligatoriska nodtaggar',
      noPlacementTags: 'Inga',
      placementTag: 'Tagg',
      placementValue: 'Värde',
      placementAddTag: 'Lägg till tagg',
      proximityHa: 'HA via TVirt Proximity',
      proximityHaRestarts: 'HA-omstarter',
      proximityHaGaveUp: 'kraschloop — HA har gett upp',
      failoverProtection: 'Skydd i degraderat kluster',
      protectionProtected: 'Skyddad',
      protectionExpendable: 'Kan offras vid degradering',
      protectionInherit: 'Ärv',
      lastStop: 'Senaste stopp',
      yes: 'Ja',
      no: 'Nej',
      tabOverview: 'Översikt',
      tabSnapshots: 'Snapshots',
      tabBackups: 'Kopior',
      hardware: 'Maskinvara',
      name: 'Namn',
      hwSystem: 'System',
      hwCpu: 'CPU',
      hwMemory: 'Minne',
      hwBoot: 'Start',
      hwIdentity: 'Identitet',
      hwCluster: 'Kluster och agent',
      cpuTopology: 'CPU-topologi',
      cpuModel: 'CPU-modell',
      cpuLimit: 'CPU-gräns',
      cpuWeight: 'CPU-vikt',
      cpuNested: "Nästlad virtualisering",
      cpuNestedHint: "Exponerar vmx/svm för gästen (endast med CPU-modellen host). På en körande VM gäller ändringen från nästa power cycle (PendingRestart); placering tillåter bara noder med nested aktiverat.",
      unlimited: 'Obegränsad',
      memory: 'Minne',
      balloon: 'Balloon',
      hugePages: 'Enorma sidor',
      hugePagesTradeoff: 'Mindre adressöversättningsarbete och minne som aldrig hamnar på disk; i utbyte förblir reservationen låst på noden så länge den virtuella maskinen kör, minnet dedupliceras inte längre, och starten misslyckas om noden har för få lediga sidor.',
      disks: 'Diskar',
      cdroms: 'CD/DVD-enheter',
      nics: 'Nätverksgränssnitt',
      slot: 'Slot',
      disk: 'Disk',
      encrypted: 'Krypterad',
      image: 'Avbild',
      emptyDrive: 'Tom enhet',
      emptyOption: '(tom)',
      network: 'Nätverk',
      mac: 'MAC',
      connected: 'Ansluten',
      unplugged: 'Frånkopplad',
      noDevices: 'Inga',
      screenshot: 'Skärmdump',
      capturedAt: 'Tagen kl.',
      noCapture: 'Ingen bild tagen',
      snapshotName: 'Namn',
      snapshotCreated: 'Skapad',
      snapshotMemory: 'Minne inkluderat',
      noSnapshots: 'Inga snapshots',
      pendingRestart: 'Väntande ändringar: de tillämpas vid nästa power cycle.',
      applied: 'tillämpat',
      appliedHint: 'VM:en kör med det här värdet — det konfigurerade värdet tillämpas vid nästa power cycle.',
      actionError: 'Åtgärden misslyckades',
      actionStillRunning: 'Åtgärden pågår fortfarande — utfallet är ännu inte känt',
      tabConsole: 'Konsol',
      consoleConnect: 'Anslut',
      consoleDisconnect: 'Koppla från',
      consoleConnecting: 'Ansluter…',
      consoleReconnecting: 'Ansluter…',
      consoleUnavailable: 'Konsolen är tillgänglig när VM:en körs eller är pausad.',
      consoleError: 'Anslutningen till konsolen misslyckades',
      consoleTaken: 'Konsolsessionen togs över av {user}',
      consoleReconnect: 'Återanslut',
      consoleCtrlAltDel: 'Ctrl+Alt+Del',
      consoleHold: 'Håll {key} nedtryckt',
      consoleFn: 'Fn…',
      consoleFullscreen: 'Öppna i helskärm i en ny flik',
      consoleLoadFailed: 'VM:en hittades inte eller otillräckliga behörigheter',
      consoleClose: 'Stäng',
      tabStats: 'Statistik',
      tabTasks: 'Tasks',
      tabLogs: 'Logg',
      statsCpu: 'CPU',
      statsMemory: 'Minne',
      statsDisk: 'Disk-I/O',
      statsRange: 'Intervall',
      statsNoData: 'Inga data i intervallet — statistiken samplas medan VM:en körs.',
      statsError: 'Kunde inte läsa in statistiken',
      cpuUsage: 'Användning',
      cpuReady: 'Ready (%RDY)',
      memUsed: 'Använt',
      memGuestAvailable: 'Tillgängligt (guest)',
      schema: 'Schema',
      consoleProtocol: 'Konsol',
      agentEnabled: 'Guest agent',
      metadataStorage: 'Metadata-storage',
      startupOnBoot: 'Start vid boot',
      startupOrder: 'Startordning',
      startupDelay: 'Startfördröjning',
      seconds: 's',
      enabled: 'Aktiverad',
      disabled: 'Inaktiverad'
    },
    actionsAvailable: 'Tillgängliga åtgärder',
    actions: {
      start: 'Starta',
      stop: 'Stäng av',
      pause: 'Pausa',
      resume: 'Återuppta',
      reset: 'Reset',
      migrate: 'Migrera',
      clone: 'Klona',
      moveStorage: 'Flytta till storage…',
      moveScope: 'Flytta till scope…',
      openConsole: 'Öppna konsolen',
      forceStop: 'Tvinga avstängning',
      markTemplate: 'Markera som template',
      unmarkTemplate: 'Gör om till VM',
      error: 'Kunde inte utföra åtgärden'
    },
    cordon: {
      confirmTitle: 'Noden är i underhåll',
      confirmHint:
        'Kordongen kan inte sänkas medan klustrets store är nere. Genom att bekräfta förklarar du att du vet det: den virtuella maskinen startar där ändå, och samtycket förblir registrerat på uppgiften.',
      confirm: 'Starta ändå'
    },
    markTemplate: {
      confirmTitle: 'Markera {name} som template?',
      confirmBody: 'Konfigurationen fryses och VM:en kan inte längre slås på — bara klonas, eller bli VM igen. Namn, anteckningar och taggar kan fortfarande ändras.',
      confirm: 'Markera som template',
      moved: '{name} är nu en template — den har flyttat till fliken Templates.'
    },
    unmarkTemplate: {
      confirmTitle: 'Göra om {name} till VM?',
      confirmBody: 'Templaten blir en vanlig VM igen: redigerbar och startbar (nästa start placerar den på en nod).',
      confirm: 'Gör om till VM',
      moved: '{name} är åter en virtuell maskin — den har flyttat till fliken Virtuella maskiner.'
    },

    // Round #123: riferimento a nodo per TAG (selettore #106) nei dialog
    // di start e migrazione — anteprima dell'insieme risolto inclusa.
    nodeByTag: {
      label: 'Per nodtagg',
      hint: 'tag=värde, kommaseparerat (AND): decidern väljer bland de matchande noderna',
      invalid: 'Ogiltigt format — använd tag=värde, kommaseparerat',
      resolved: 'Matchande medlemmar: {nodes}'
    },
    migrate: {
      title: 'Live migration',
      submit: 'Migrera',
      target: 'Målnod',
      auto: 'Automatiskt (Proximity)',
      hint: 'VM:en flyttas utan power cycle. Varje storage den rör måste vara delad; en pausad VM migrerar pausad.',
      error: 'Migreringen avvisades'
    },
    moveStorage: {
      title: 'Flytta till storage',
      submit: 'Flytta',
      target: 'Mål-storage',
      noTargets: 'Ingen storage tar emot diskar',
      hint: 'Alla diskar på den avstängda VM:en flyttas till den valda storagen, en i taget, med bibehållet id — de som redan är framme hoppas över. Förloppet syns på task-sidan.',
      error: 'Flytten avvisades'
    },
    moveScope: {
      title: 'Flytta till scope',
      submit: 'Flytta',
      target: 'Mål-scope',
      hint: 'VM:en byter scope omedelbart — id och diskar består, ägda diskar följer med, och den kan förbli påslagen. I dag bor den i {scope}. Vem som ser den ändras med scopet.',
      error: 'Scope-flytten avvisades'
    },
    start: {
      title: 'Starta VM',
      submit: 'Starta',
      target: 'Målnod',
      auto: 'Automatiskt (rekommenderas)',
      recommended: 'rekommenderas',
      hint: 'Välj en målnod eller låt Proximity välja bland de giltiga kandidaterna. Noder som inte kan husera den är inaktiverade, med orsaken angiven.',
      error: 'Kunde inte starta VM:en'
    },
    console: {
      media: 'CD/DVD-enheter',
      mediaGuestToolsHint: 'Innehåller TVirt Guest Tools — härifrån kan du mata ut dem eller ta bort enheten',
      slotOpsDeferred: 'På den här profilen tillämpas tillägg och borttagning av enheter vid nästa power cycle (mediebyten är omedelbara).',
      mountGuestTools: 'Montera TVirt Guest Tools',
      ejectGuestTools: 'Mata ut TVirt Guest Tools',
      bootOrder: 'Boot-ordning',
      bootOrderHint: 'Den nya ordningen sparas direkt och tillämpas vid nästa power cycle — konsolsessionen förblir ansluten.'
    },
    snapshots: {
      create: 'Skapa snapshot',
      createTitle: 'Skapa en snapshot',
      createSubmit: 'Skapa',
      name: 'Namn',
      nameHint: 'Bokstäver, siffror, punkt, bindestreck, understreck.',
      consistencyHint: 'Konsistensen är automatisk: guest-agenten fryser filsystemen när den svarar; annars pausas VM:en ett ögonblick kring snapshoten.',
      memory: 'Inkludera minnet',
      memoryHint: 'Fångar det levande RAM-minnet: en återställning återupptar VM:en i körande läge. Kräver att alla diskar är qcow2.',
      currentChip: 'Du är här',
      revert: 'Återställ',
      revertTitle: 'Återställa {name}?',
      revertBody: 'Diskarna återgår till snapshotens tillstånd; allt som hänt därefter går förlorat. En snapshot med enbart diskar kräver att VM:en är stoppad.',
      delete: 'Ta bort',
      deleteTitle: 'Ta bort snapshoten {name}?',
      deleteBody: 'Återställningspunkten försvinner; diskarnas innehåll förblir intakt.',
      deleteMergeHint: 'Dess delta slås samman i {children}: varje senare återställningspunkt förblir giltig.',
      deleteDuplication: 'Jag accepterar dubbleringen',
      deleteDuplicationHint: 'Deltat kopieras in i var och en av de {count} läsarna (barn-snapshots och, om detta är det aktuella, det aktiva huvudet): det använda utrymmet kan växa i stället för att krympa.',
      error: 'Snapshot-operationen avvisades'
    },
    clone: {
      title: 'Klona VM',
      submit: 'Klona',
      name: 'Kopians namn',
      storage: 'Mål-storage för diskarna',
      sameStorage: 'Samma som källan',
      full: 'Fullständig kopia',
      fullHint: 'Kopierar varje byte och kapar bandet till källdiskarna. Standard är en linked clone: omedelbar, men kedjad till källan (endast qcow2).',
      hint: 'Klonen behåller källans konfiguration och firmware; MAC-adresser och TPM-identitet är nya.',
      markAs: 'Klonens typ',
      markAsInheritVm: 'Som källan (VM)',
      markAsInheritTemplate: 'Som källan (template)',
      markAsVm: 'Virtuell maskin',
      markAsTemplate: 'Template',
      markAsHintVm: 'Välj Template för att befordra kopian i ett enda steg.',
      markAsHintTemplate: 'Välj Virtuell maskin för att deploya från den här templaten i ett enda steg.',
      error: 'Kloningen avvisades'
    },
    bulk: {
      selected: 'valda',
      deleteTitle: {
        one: 'Ta bort {count} vald VM?',
        other: 'Ta bort {count} valda VM?'
      },
      deleteBody: 'Varje VM passerar samma spärrar som en enskild delete; avslag rapporteras per objekt.',
      done: 'accepterade',
      refused: 'avvisade'
    },
    delete: {
      button: 'Ta bort',
      confirmTitle: 'Ta bort {name}?',
      confirmBody: 'Den virtuella maskinen och diskarna den äger kommer att tas bort. Operationen går inte att ångra.',
      keepDisks: 'Behåll diskarna',
      keepDisksHint: 'Diskar som skapades med VM:en blir kvar i sin storage som fristående diskar.',
      confirm: 'Ta bort',
      cancel: 'Avbryt',
      error: 'Borttagningen misslyckades',
      blockedPhase: 'Stäng av VM:en först',
      blockedProtected: 'VM:en är skyddad — ta bort skyddet först',
      blockedDeleting: 'Borttagning pågår redan'
    },
    logs: {
      title: 'Logg',
      subtitle: 'Strukturerade logg-frames från de tasks som rör den här VM:en',
      when: 'När',
      task: 'Task',
      level: 'Nivå',
      message: 'Meddelande',
      empty: 'Ännu ingen logg',
      loadError: 'Kunde inte läsa in loggarna — är TVirt-backenden nåbar?'
    },
    stop: {
      title: 'Stäng av virtuell maskin',
      modeGraceful: 'Graceful avstängning',
      modeGracefulHint: 'Guest-operativsystemet ombeds stänga av sig på naturlig väg (ACPI); om det ignorerar begäran utlöses tvingad avstängning efter timeouten.',
      modeForced: 'Tvingad avstängning',
      modeForcedHint: 'Bryter strömmen omedelbart, som att dra ur sladden.',
      timeout: 'Fallback-timeout (sekunder)',
      timeoutHint: 'Väntetid som guesten får innan avstängningen tvingas'
    },
    createFromScratch: 'Från grunden',
    createFromTemplate: 'Från template',
    createQuickDeploy: 'TVirt QuickDeploy',
    quickDeploy: {
      title: 'TVirt QuickDeploy',
      submit: 'Utför deploy',
      error: 'Deploy misslyckades',
      compatNote: 'QuickDeploy kräver en QuickDeploy-kompatibel mall: plattformen anpassar gästen (nätverk, domän, aktivering) vid första starten.',
      template: 'Mall',
      noTemplates: 'Ingen mall deklarerar QuickDeploy-kompatibilitet ännu — deklarera den från fliken Mallar (Linux med cloud-init, Windows med cloudbase-init efter sysprep)',
      osLinux: 'Linux (cloud-init)',
      osWindows: 'Windows (cloudbase-init)',
      hostname: 'Värdnamn',
      hostnameHint: 'Värdnamn eller FQDN; tomt = VM:ens namn (Windows: högst 15 tecken)',
      ip: 'IP-adress',
      ipHint: 'Värd och prefix, t.ex. 192.168.122.101/24; tomt = DHCP',
      gateway: 'Gateway',
      dns: 'DNS-servrar',
      dnsHint: 'Upp till tre, kommaseparerade',
      count: 'Instanser',
      countHint: 'Fler än en: namngivna <namn>-1…-N, endast DHCP',
      user: 'Användare',
      userHint: 'Tomt = avbildningens standardanvändare (Linux) eller Administrator (Windows)',
      password: 'Lösenord',
      passwordHint: 'Skrivs in i den genererade user-datan, som plattformen sedan förklarar hemlig: ingen läser den igen',
      sshKeys: 'Publika SSH-nycklar',
      sshKeysHint: 'En per rad (ssh-ed25519 AAAA… kommentar)',
      productKey: 'Windows-produktnyckel',
      kmsServer: 'KMS-server',
      kmsHint: 'Värd eller värd:port — kräver en produktnyckel (en KMS-klientnyckel)',
      adDomain: 'Anslut till Active Directory-domän',
      adDomainHint: 'Tomt = ingen domänanslutning',
      adUser: 'Anslutningskonto',
      adPassword: 'Anslutningskontots lösenord',
      adOu: 'Mål-OU (valfritt)',
      advanced: 'Avancerat: råa dokument',
      userData: 'user-data (rå)',
      userDataHint: 'Åsidosätter den genererade user-datan: användare, lösenord, nycklar och Windows-fälten ovan måste lämnas tomma',
      networkConfig: 'network-config (rå)',
      networkConfigHint: 'Åsidosätter det genererade nätverket: IP, gateway och DNS ovan måste lämnas tomma',
      secret: 'Behandla den råa user-datan som hemlig',
      secretHint: 'Markerad som hemlig slutar API:et returnera den till någon, och den reser förseglad med masterpass i Checkpointen',
      startNow: 'Starta direkt',
      startNowHint: 'Varje instans startar så snart den är definierad; seedet byggs vid den starten'
    },
    create: {
      nicAttachmentNetwork: 'Logiskt nätverk (fabric)',
      nicNetwork: 'Logiskt nätverk',
      nicNetworkHint: 'Den REKOMMENDERADE vägen (F3): vNIC:en realiseras på den HÄRLEDDA bryggan på den betjänande noden — bryggan föds vid den explicita fabric-applyn, och en start på en nod som ännu inte bär den avslår talande. När flottans sista referens försvinner faller bryggan ut vid nästa apply.',
      button: 'Skapa VM',
      title: 'Skapa virtuell maskin',
      dialogTitle: 'Skapa virtuell maskin',
      stepGeneral: 'Allmänt',
      stepGeneralHint: 'Namn och profil',
      stepCompute: 'CPU och RAM',
      stepComputeHint: 'Topologi och storlek',
      stepDisks: 'Diskar',
      stepDisksHint: 'Skapa eller anslut',
      stepCdroms: 'CD/DVD',
      stepCdromsHint: 'Enheter och medier',
      stepNetwork: 'Nätverk',
      stepNetworkHint: 'NIC: trunk eller bridge',
      stepSummary: 'Sammanfattning',
      stepSummaryHint: 'Granska och skapa',
      name: 'Namn',
      nameHint: 'Gemener, siffror och bindestreck (DNS-1123)',
      nextButton: 'Nästa',
      prevButton: 'Tillbaka',
      submitButton: 'Skapa',
      creating: 'Skapar…',
      sockets: 'Socket',
      cores: 'Kärnor per socket',
      threads: 'Trådar per kärna',
      totalVcpus: 'Totalt antal vCPU',
      memoryGib: 'Minne (GiB)',
      cpuModelHint: "'host' exponerar hostens CPU",
      cpuLimitHint: 'Tak i host-kärnor — tomt = obegränsat',
      cpuNestedHint: "Exponerar vmx/svm för gästen så att den kan köra sin egen hypervisor — kräver CPU-modellen host och en nod med nested aktiverat",
      newDisk: 'Ny disk',
      attachDisk: 'Anslut befintlig disk',
      diskStorage: 'Storage',
      diskSize: 'Storlek (GiB)',
      diskSelect: 'Disk',
      addDisk: 'Lägg till disk',
      addCdrom: 'Lägg till CD/DVD-enhet',
      addNic: 'Lägg till nätverksgränssnitt',
      remove: 'Ta bort',
      slotLimit: 'Slot-gränsen är nådd',
      cdromImage: 'Avbild (tom enhet om ingen)',
      nicAttachment: 'Anslutning',
      nicAttachmentTrunk: 'Overlay-trunk',
      nicAttachmentBridge: 'Host-bridge',
      nicUntagged: 'Untagged overlay',
      nicUntaggedNone: 'Ingen (endast tagged)',
      nicTrunkHint: 'Minst en sida: ett untagged overlay och/eller tagged VLAN-mappningar — VM:en kan bara köra på de hostar som varje refererat overlay deklarerar',
      nicTaggedVlan: 'VLAN-ID',
      nicTaggedOverlay: 'Overlay-nätverk',
      addTagged: 'Lägg till tagged VLAN',
      nicBridge: 'Host-bridgens namn',
      nicBridgeHint: 'NM-bridge per namn — VM:en kan bara köra på servrar vars host network deklarerar den här bridgen',
      nicMac: 'MAC (auto om tomt)',
      noDisksHint: 'Inga diskar: VM:en får bara de CD/DVD-enheter du lägger till.',
      noCdromsHint: 'Ingen CD/DVD-enhet: lägg till en för att starta från en ISO-avbild.',
      mountGuestTools: 'Montera TVirt Guest Tools vid första starten',
      mountGuestToolsHint: 'Lägger ISO:n med virtio-drivrutinerna och guest-agenten i en tom CD-enhet (som läggs till vid behov) — Windows-installeraren behöver den för att se diskarna.',
      noNicsHint: 'Inga nätverksgränssnitt: VM:en startar utan konnektivitet.',
      taggedMappings: 'Tagged VLAN-mappningar',
      summaryDevices: 'Enheter',
      bootOrderTitle: 'Boot-ordning',
      bootOrderHint: 'Dra för att ändra ordningen — den första startbara enheten vinner; NIC:ar bootar PXE',
      bootOrderUp: 'Flytta upp',
      bootOrderDown: 'Flytta ner',
      createError: 'Skapandet misslyckades'
    },
    edit: {
      button: 'Redigera',
      title: 'Redigera virtuell maskin',
      cancel: 'Avbryt',
      save: 'Spara',
      error: 'Ändringen misslyckades',
      modelStoppedOnly: 'Kan bara ändras när VM:en är avstängd',
      firmwareStoppedOnly: 'Firmware kan bara ändras när VM:en är avstängd — vid nästa start startar maskinen på den nya firmwaren och UEFI-variablerna behålls',
      hugePagesStoppedOnly: 'Kan bara ändras när den virtuella maskinen är avstängd — vid nästa start byggs minnet på det nya underlaget',
      runningHint: 'Ändringarna tillämpas vid nästa power cycle',
      sectionCpu: 'CPU',
      sectionMemory: 'Minne',
      sectionPolicy: 'Policyer'
    },
    devices: {
      networkChip: 'fabric-nätverk',
      title: 'Enheter',
      usb: 'USB',
      gpu: 'GPU',
      addUsb: 'Lägg till USB-enhet',
      addUsbTitle: 'Begär en klass av USB-enheter',
      usbClassHint:
        'VM:en begär en KLASS av USB-enheter (ett värde på en usb-device-tagg), aldrig en specifik enhet: vid starten väljs och reserveras den konkreta lediga enheten på noden. Tagga registrerade enheter i Kluster › USB- och PCIe-resurser.',
      usbTag: 'Tagg (usb-device)',
      usbValue: 'Klassens värde',
      noUsbTags: 'Ingen usb-device-tagg — skapa en och tagga registrerade enheter i Kluster › USB- och PCIe-resurser.',
      noUsbValues: 'Den här taggen har inga deklarerade värden ännu.',
      usbEmpty: 'Inga USB-krav — lägg till en klass för att skicka in en enhet vid starten.',
      usbClassChip: 'klass',
      usbPortChip: 'port',
      usbUnclaimed: 'Ingen enhet reserverad — löses vid VM:ens start.',
      addGpu: 'Lägg till GPU',
      addGpuTitle: 'Begär en GPU-klass',
      gpuClassHint:
        'VM:en begär en KLASS av GPU:er (ett värde på en gpu-device-tagg), aldrig ett specifikt kort: vid starten väljs och reserveras det konkreta lediga kortet på noden, och hela dess IOMMU-grupp skickas med TILLSAMMANS. Tagga registrerade GPU:er i Kluster › USB- och PCIe-resurser.',
      gpuTag: 'Tagg (gpu-device)',
      gpuValue: 'Klassens värde',
      noGpuTags: 'Ingen gpu-device-tagg — skapa en och tagga registrerade GPU:er i Kluster › USB- och PCIe-resurser.',
      noGpuValues: 'Den här taggen har inga deklarerade värden ännu.',
      gpuEmpty: 'Inga GPU-krav — lägg till en klass för att skicka in ett kort vid starten.',
      gpuClassChip: 'klass',
      gpuGroupChip: 'IOMMU-grupp ×',
      gpuUnclaimed: 'Inget kort reserverat — löses vid VM:ens start.',
      gpuPowerCycle: 'Ingen GPU-hotplug — ändringarna gäller från nästa power cycle (PendingRestart)',
      actions: 'Åtgärder',
      attachDisk: 'Lägg till disk',
      attachDiskTitle: 'Lägg till en disk',
      attach: 'Anslut',
      noFreeDisks: 'Inga oanvända diskar — skapa en i Virtuella maskiner › Oanvända diskar.',
      addCdrom: 'Lägg till enhet',
      addCdromTitle: 'Lägg till en CD/DVD-enhet',
      editCdromTitle: 'Byt CD/DVD-avbild',
      changeMedia: 'Byt CD/DVD-avbild',
      ejectMedium: 'Mata ut',
      mountGuestTools: 'Montera TVirt Guest Tools',
      guestToolsMounted: 'TVirt Guest Tools monterade',
      guestToolsClickMount: 'Lägger TVirt Guest Tools-ISO:n i den första tomma CD/DVD-enheten',
      guestToolsClickUnmount: 'Klicka för att mata ut — enheten blir kvar, tom',
      guestToolsNoSlot: 'Ingen tom CD/DVD-enhet — lägg till en enhet (eller mata ut ett medium) för att montera TVirt Guest Tools',
      guestToolsSkew: 'Monterad v{pinned}; nod {node} levererar nu v{current}: mata ut och montera om för att uppdatera',
      ejectGuestTools: 'Mata ut TVirt Guest Tools (enheten blir kvar, tom)',
      guestToolsEjectConfirmTitle: 'Mata ut TVirt Guest Tools?',
      guestToolsEjectConfirmBody: 'Mediet matas ut ur den påslagna VM:en — CD/DVD-enheten blir kvar, tom.',
      applyLive: 'Tillämpa direkt (VM:en är påslagen)',
      addNic: 'Lägg till gränssnitt',
      addNicTitle: 'Lägg till ett nätverksgränssnitt',
      editNicTitle: 'Redigera nätverksgränssnitt',
      bridgeChip: 'bridge',
      cable: 'Virtuell kabel',
      plug: 'Anslut den virtuella kabeln',
      unplug: 'Koppla ur den virtuella kabeln',
      remove: 'Ta bort',
      removeTitle: 'Ta bort {device}?',
      removeBody: 'På en påslagen VM tillämpas ändringen vid nästa power cycle. Diskar och avbilder kopplas bara från — de tas aldrig bort.'
    }
  }
}
